<template>
    <ExpandableLayout :title="$t('Фильтр')">
        <template #title.append>
            <v-btn :disabled="clearDisabled" @click="handleClear" class="ml-auto" text>{{ $t('Очистить фильтр') }}</v-btn>
        </template>
        <v-form @submit="handleSubmit()" onsubmit="return false;" :ref="formRef">
            <slot></slot>
            <v-btn type="submit" block :color="$vuetify.theme.themes.dark.primary">
                <span class="white--text">{{ $t('Применить') }}</span>
            </v-btn>
        </v-form>
    </ExpandableLayout>
</template>
<script>
import ExpandableLayout from '@/components/ui/ExpandableLayout';
import FormValidator from '@/mixins/FormValidator';
import { cloneObject } from '@/utils';
export default {
    props: ['value', 'defaultFilterData'],
    mixins: [FormValidator],
    components: {
        ExpandableLayout
    },
    computed: {
        clearDisabled() {
            return JSON.stringify(this.value) === JSON.stringify(this.defaultFilterData);
        }
    },
    methods: {
        handleSubmit() {
            if (!this.validateForm()) return;
            this.$emit('submit');
        },
        handleClear() {
            this.$emit('input', cloneObject(this.defaultFilterData) || {});
            this.$emit('submit');
        }
    }
};
</script>
<style lang="scss">
.mobile-filter {
    &__row {
        display: flex;
        align-items: center;
        border-bottom: thin solid rgba(0, 0, 0, 0.12);
        margin-bottom: 10px;
        padding-bottom: 10px;
        & > * {
            width: 50%;
        }
    }
}
</style>
